<template>

    <div 
         class="m-6">
        <div class="w-full">
            <label for="disturbance-codes"
                class="float-left text-sm font-semibold text-blue-800
                        mb-1 ml-1">
                Disturbance Type
            </label>
            <select id="disturbance-codes" 
                    @change="updateSelection" 
                    class="w-full border border-gray-400 text-gray-700 
                        rounded shadow text-sm p-1 ml-1">
                <option value=0 selected>
                    Select
                </option>
                <option v-for="code in code_data" 
                    v-bind:value="code.code"
                    :key="code.code"
                    :selected="isSelected(code.code)">
                    {{ code.description }}
                </option>
            </select>
        </div>
    </div>
  
</template>

<script>

    import axios from 'axios';

    export default {
               
        name: 'DisturbanceCodes',

        props: ["current_code"],

        emits:['code_selected', 'codes'],

        data(){
            return{
                code_data: null,
                selected_code: null
            }
        },

        methods:{

            getCodes(){
                const action = 'get_codes';
                let url = '';
                url += 'https://'; 
                url += '8to08gnyej.execute-api.us-east-1.amazonaws.com/';
                url += 'default/sadc_utilities?';
                url += `action=${action}`;

                axios
                .post(url)
                .then(response => {
                    
                    if(Object.prototype.hasOwnProperty.call(
                                                response.data,'message')){                                            
                        console.error( "Error in 'get_codes'",
                                        response.data.message)
                        return false;
                    }else{
                        this.code_data = response.data;
                        this.$emit('codes', this.code_data);
                        return true;
                    }
                })
                .catch(error => {
                    console.error( "Error in 'get_codes'", error)
                    return false;
                });
            },

            updateSelection(){
                const code = document.getElementById('disturbance-codes').value;
                this.$emit("code_selected", parseInt(code));
            },

            isSelected(code) {
                 return code === this.current_code; 
            }
        },

        mounted(){
            this.getCodes();
        }
    }
</script>